import React, { useState, useContext, useEffect }  from 'react'
import "./Inbox.css"
import { Row, Col, Button, Form } from 'react-bootstrap'
import { Checkbox, Radiobox, Loading, Container, HeaderTitle } from '../Library'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { listCompany } from "../Network/Company"
import { listDepartment } from '../Network/Department'
import { listUser } from '../Network/User'
import { SendMassage } from '../Network/Inbox'
import DatePicker from "react-datepicker";
import dayjs from 'dayjs'
import { setDocumentTitle } from '../AppTitle'

function Inbox() {
    const [sender, setSender] = useState("");
    const [message, setMessage] = useState("");
    const [channel, setChannel] = useState("inbox");
    const [deptIds, setDeptIds] = useState("");
    const [compIds, setCompIds] = useState("");
    const [userIds, setUserIds] = useState("");

    const myDate = new Date()

    const [date_selete, setDate_selete] = useState(myDate)

    const [sendto, setSendto] = useState("")

    const [selectedDepartment, setSelectedDepartment] = useState([])
    const [selectedUser, setSelectedUser] = useState([])
    const [companyList, setCompany] = useState([])
    const [UserList, setUser] = useState([])
    const [departmentList, setDepartment] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState([])

    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.Inbox;
    const langError = langCx.lang.error;
    const notifyCx = useContext(NotifyContext);

    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);
    


    const onSubmit = () =>{
        if( !sender || !message || !channel){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        else if (!sendto){
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }

        else if(sendto){
            setError(true);
            if(sendto === "company" && !compIds){
                notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
                return;
            }else if(sendto === "department" && !deptIds){
                notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
                return;
            }else if(sendto === "users" && !userIds){
                notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
                return;
            }
        }

        let schedule_date = dayjs(date_selete).valueOf()

        setLoading(true);
        SendMassage(
            sender,
            message,
            channel,
            deptIds,
            compIds,
            userIds,
            schedule_date,
            ()=>{
                setLoading(false)
                notifyCx.showNotify(
                    lang.sent_massage,
                    lang.sent_massage_desc,
                    0)
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Error", error.message, 2)
            }
        )
    }

    const fetchCompany = () => {
        listCompany(
            (data)=>{
                setCompany(data)
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
            }
        )
    }

    const fetchUser = (selectedDepartment, selectedCompany) =>{
        listUser(selectedDepartment, selectedCompany,
            (data)=>{
                setUser(data);
            },
            (error)=>{
                notifyCx.showNotify(lang.something_wrong, error.message, 2)
            }
        )
    }


    const fetchDepartment = (id) =>{
        listDepartment(id,
            (data)=>{
                setDepartment(data)
            },
            (error)=>{
                notifyCx.showNotify(lang.something_wrong, error.message, 2)
            })
    }

    const clearForm = () =>{
        setSelectedCompany("")
        setCompIds("")
        setDeptIds("")
        setUserIds("")
    }

    useEffect(() => {
        setDocumentTitle("Inbox message")
        fetchCompany()
        fetchUser("", "")
    }, [])

    return (
        <Container id="inbox" topbarTitle={langCx.lang.sidebar.inbox}>
            { isLoading ? <Loading/> : null }
            <HeaderTitle title={lang.inbox_message}/>
            <div className="inbox-container">
            <Row style={{width: "100%"}}>
                <Col md={10} lg={8} xl={8}>
                    <Form
                        onSubmit={(e)=>{
                            e.preventDefault();
                            onSubmit();
                        }}
                    >

                        <Form.Label className = "sender-label">{lang.sender_name}</Form.Label>
                        <Form.Control 
                            className = "sender-form"
                            value={sender}
                            isInvalid={isError && !sender}
                            onChange={(e)=>setSender(e.target.value)} 
                        />
                        <Form.Label className = "message-label">{lang.message}</Form.Label>
                        <Form.Control 
                            className = "message-form"
                            value={message}
                            isInvalid={isError && !message}
                            onChange={(e)=>setMessage(e.target.value)} 
                        />
                    <hr/>
                    <Form.Group controlId="formHorizontalRadios">
                        <div className = "radioGroup">
                            <Form.Label className = "Radio-label">{lang.channel}</Form.Label>
                            <div>
                            <div style={{display: 'flex'}}>
                            <Radiobox
                                style={{ marginLeft: '1em' }}
                                label={lang.lifelink_inbox}
                                name="formHorizontalRadios"
                                id="formHorizontalRadios1"
                                value = "inbox"
                                checked={channel === "inbox"}
                                onChange={(e)=>setChannel(e.target.value)}
                            />
                            <Radiobox
                                style={{ marginLeft: '1em' }}
                                label={lang.email} 
                                name="formHorizontalRadios"
                                id="formHorizontalRadios2"
                                value = "mail"
                                checked={channel === "mail"}
                                onChange={(e)=>setChannel(e.target.value)}
                            />
                            <Radiobox
                                style={{ marginLeft: '1em' }}
                                label={lang.both} 
                                name="formHorizontalRadios"
                                id="formHorizontalRadios3"
                                value = "both"
                                checked={channel === "both"}
                                onChange={(e)=>setChannel(e.target.value)}
                            />
                            </div>
                            </div>
                        </div>
                    </Form.Group>
                    <hr/>
                    <Form.Group>
                    <Form.Label className = "date-label">{lang.date}</Form.Label>
                    <DatePicker
                        selected={date_selete}
                        onChange={(date)=>setDate_selete(date)}
                        className="form-control" 
                        dateFormat="d MMMM yyyy - H:mm"
                        showTimeSelect
                    />
                    </Form.Group>

                    <Form.Group controlId="formsendto">
                        <div style={{display: 'flex'}}>
                            <Form.Label className = "Checkbox-label">{lang.send_to}</Form.Label>
                            <Radiobox                                 
                                style={{ marginLeft: '1em' }} 
                                className = "CompaniesCheckbox" 
                                name="formsendto"
                                label={lang.companies}
                                isinvalid={isError && !sendto ? true: false}
                                onChange={() => {
                                    clearForm()
                                    setSendto("company")
                                }}
                            />
                            <Radiobox
                                style={{ marginLeft: '1em' }} 
                                className = "DepartmentsCheckbox" 
                                name="formsendto"
                                label={lang.departments}
                                isinvalid={isError && !sendto ? true: false}
                                onChange={() => {
                                    clearForm()
                                    setSendto("department")
                                }} 
                            />
                            <Radiobox
                                style={{ marginLeft: '1em' }} 
                                className = "UsersCheckbox" 
                                name="formsendto"
                                label={lang.users}
                                isinvalid={isError && !sendto ? true: false}
                                onChange={() => {
                                    clearForm()
                                    setSendto("users")
                                }}  
                            />
                        </div>
                    </Form.Group>

                    { sendto === "users" ?
                    <>
                    <Form.Label className = "Companies-label">{lang.companies_name}</Form.Label>
                    <Form.Control as="select" className ="Companies-select"
                        onChange={(e)=>{
                            
                            if(e.target.value !== ""){
                                setSelectedCompany(e.target.value)
                                fetchUser("", e.target.value)
                            }else{
                                setSelectedCompany("")
                                fetchUser("", "")
                            }    
                        }}>
                        <option value="">{lang.select_company}</option>
                            { companyList.map((item, key)=>
                        <option key={key} value={item.id}>{item.name}</option>
                        )}
                    </Form.Control>
                    <Form.Label className = "User-label">{lang.users_name}</Form.Label>
                    <Form.Control as="select" className ="User-select"
                       isInvalid={isError && !userIds}
                       onChange={(e)=>setUserIds(e.target.value)}>
                           <option value="">{lang.select_user}</option>
                           { UserList.map((item, key)=>
                           <option key={key} value={item.id}>{item.firstName+' '+item.lastName+' - '+item.email}</option>
                           )}
                    </Form.Control>
                    </>
                    : null
                    }

                    { sendto === "company" ?
                    <>
                    <Form.Label className = "Companies-label">{lang.companies_name}</Form.Label>
                    <Form.Control as="select" className ="Companies-select"
                        isInvalid={isError && !compIds}
                        onChange={(e)=>{
                            setCompIds(e.target.value)  
                        }}>
                        <option value="">{lang.select_company}</option>
                            { companyList.map((item, key)=>
                        <option key={key} value={item.id}>{item.name}</option>
                        )}
                    </Form.Control>
                    </>
                    :null
                    }
                    
                    { sendto === "department" ?
                    <>
                    <Form.Label className = "Companies-label">{lang.companies_name}</Form.Label>
                    <Form.Control as="select" className ="Companies-select"
                        isInvalid={isError && !selectedCompany}
                        onChange={(e)=>{
                            if(e.target.value !== ""){
                                setSelectedCompany(e.target.value)
                                fetchDepartment(e.target.value)
                            }else{
                                setDepartment([])
                                setSelectedCompany("")
                            }   
                            setDeptIds("")
                        }}>
                        <option value="">{lang.select_company}</option>
                            { companyList.map((item, key)=>
                        <option key={key} value={item.id}>{item.name}</option>
                        )}
                    </Form.Control>

                    <Form.Label className = "Department-label">{lang.departments_name}</Form.Label>
                    <Form.Control as="select" className ="Department-select"
                            disabled={!selectedCompany}
                            value={deptIds}
                            isInvalid={isError && !deptIds}
                            onChange={(e)=>setDeptIds(e.target.value)}>
                                <option value="">{lang.select_department}</option>
                                { departmentList.map((item, key)=>
                                <option key={key} value={item.id}>{item.name}</option>
                                )}
                    </Form.Control>
                    </>
                    :null
                    }
                    <hr/>
                    <Button type="submit" className = "Send-button" >
                        {lang.send} 
                    </Button>

                    </Form> 
                </Col>
                
            </Row>
            </div>
        </Container>
    )
}

export default Inbox
